<template>
    <div>
        <page-title heading="Edit Data Dokter" :breadcrumb="[
                {
                    label: 'Daftar Dokter',
                    link : '/dokter'
                },
                {
                    label: 'Edit Dokter',
                    active: true
                }
            ]" />
        <template v-if="this.formData.status != 1">
            <div>
                <div class="container-fluid mb-2 no-padd">
                    <div class="row justify-content-center">
                        <div class="col-sm-12 ">
                            <div class="card-body" style="background: #eaf0f6; padding:0.5rem;">
                                <b-row>
                                    <b-col sm="1" class="text-center mt-2" style="padding-right: 5px; padding-left: 5px;">
                                        <font-awesome-icon size="3x" style="color: #5565f3; " icon="clipboard-list" />
                                    </b-col>
                                    <b-col sm="10" class="mt-2" style="padding-left: 0px; font-size: 14px;">
                                        <label style="margin-bottom:0.2rem;">
                                            <strong>
                                                &#x2022; Apabila alamat email diubah, maka akan dilakukan <label style="color: #5565f3;">pengiriman email aktivasi ulang</label> ke email baru.
                                            </strong>
                                        </label>
                                        <br/>
                                        <label>
                                            <strong>
                                                &#x2022; Apabila status diubah menjadi <label style="color: #e4413e; ">non-aktif</label>, akan menyebabkan pengguna <label style="color: #e4413e; ">tidak dapat melakukan login.</label>
                                            </strong>
                                        </label>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div class="container-fluid">
            <div class="card card-box">
                <div class="card-body">
                    <b-row>
                        <b-col lg="3" sm="3" v-show="bpjsAuthValid">
                          <label class="font-weight-bold">Kode Dokter BPJS</label>
                          <p class="font-weight-bold m-0 text-primary" style="font-size:10px;">Pilih kode dokter jika dokter terdaftar di Pcare</p>
                          <p class="font-weight-bold m-0 text-white" style="font-size:10px;">space</p>
                        </b-col>
                        <b-col sm="3">
                            <label class="font-weight-bold">Nama Dokter</label>
                            <label style="color:red"> *</label>
                            <p class="font-weight-bold m-0 text-primary" style="font-size:10px;">
                                Lengkap dengan gelar depan & belakang jika ada
                            </p>
                            <p class="font-weight-bold m-0 text-danger" style="font-size:10px;">
                                Cth:Prof.dr.John Wick, Sp.PD
                            </p>
                        </b-col>
                        <b-col sm="3">
                            <label class="font-weight-bold">Alamat Email</label>
                            <label style="color:red"> *</label>
                        </b-col>
                        <b-col sm="3">
                            <label class="font-weight-bold">No. Handphone</label>
                            <label style="color:red"> *</label>
                        </b-col>
                        <b-col sm="3" v-show="!bpjsAuthValid">
                            <label class="font-weight-bold">Spesialisasi</label>
                            <label style="color:red"> *</label>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="3" sm="3" v-show="bpjsAuthValid">
                            <vue-select-x
                              style="font-size:13px"
                              :options="dokterBpjsList"
                              v-model="selectedDokterBpjs"
                              :ref="'kode_dokter_bpjs'"
                              placeholder="Pilih Kode Dokter BPJS"
                              :keyOpt="'kode_dokter_bpjs'"
                              :isClearable="true"
                              @input="
                                onInputKodeBpjs(
                                  $event,
                                )
                              "
                            >
                            </vue-select-x>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group style="position: relative">
                                <b-form-input
                                    v-model="formData.nama"
                                    maxlength="50"
                                    type="text"
                                    required
                                    ref="nama"
                                />
                                <template v-if="formData.nama == '' || formData.nama == null">
                                    <label style="color: red">Kolom harus diisi</label>
                                </template>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group style="position: relative">
                                <b-form-input
                                    v-model="formData.email"
                                    maxlength="50" type="email"
                                    required
                                    ref="email"
                                    @input="cekValueEmail($event)"
                                />
                                <template v-if="formData.email == '' || formData.email == null">
                                    <label style="color: red">Kolom harus diisi</label>
                                </template>
                                <template v-else-if="failedEmail">
                                    <label style="color: red">Format email salah</label>
                                </template>
                                <template v-else-if="!validasiEmail && !loadEdit">
                                    <label style="color: red">Email sudah digunakan</label>
                                </template>
                                <template v-else-if="validasiEmail && !loadEdit">
                                    <label style="color: #1bc943">Email dapat digunakan</label>
                                </template>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group style="position: relative">
                                <b-form-input
                                    v-model="formData.nomor_telp"
                                    maxlength="15"
                                    type="text"
                                    required
                                    ref="nomor_telp"
                                    @input="cekValueHP($event)"
                                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                                />
                                <template v-if="formData.nomor_telp == '' || formData.nomor_telp == null">
                                    <label style="color: red">Kolom harus diisi</label>
                                </template>
                                <template v-else-if="formData.nomor_telp.match(/[^0-9/]+/) !== null">
                                    <label style="color: red">Hanya bisa menulis angka</label>
                                </template>
                                <template v-else-if="formData.nomor_telp.length < 10">
                                    <label style="color: red">No.handphone minimal 10 karakter</label>
                                </template>
                                <template v-else-if="formData.nomor_telp.length > 15">
                                    <label style="color: red">No.handphone maksimal 15 karakter</label>
                                </template>
                                <template v-else-if="!validasiNoHP && !loadEdit">
                                    <label style="color: red">No. Handphone sudah digunakan</label>
                                </template>
                                <template v-else-if="validasiNoHP && !loadEdit">
                                    <label style="color: #1bc943">No. Handphone dapat digunakan</label>
                                </template>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3" v-show="!bpjsAuthValid">
                            <b-form-group style="position: relative">
                                <vue-select
                                    :options="spesialisasi"
                                    v-model="selectedSpesialisasi"
                                    placeholder="Pilih Spesialisasi"
                                />
                                <template v-if="selectedSpesialisasi == '' || selectedSpesialisasi == null">
                                    <label style="color: red">Kolom harus dipilih</label>
                                </template>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="3" v-show="bpjsAuthValid">
                            <label class="font-weight-bold">Spesialisasi</label>
                            <label style="color:red"> *</label>
                        </b-col>
                        <b-col lg="3" sm="3">
                            <label class="font-weight-bold">SIP Dokter</label>
                            <label style="color:red"> *</label>
                            <p class="font-weight-bold m-0 text-primary" style="font-size:10px;">
                                Lengkap dengan simbol/tanda baca
                            </p>
                            <p class="font-weight-bold m-0 text-danger" style="font-size:10px;">
                                Cth:446/015/SIP-DS/III.00-WW/IV/2019
                            </p>
                        </b-col>
                        <b-col lg="3" sm="3">
                            <label class="font-weight-bold">Masa Berlaku SIP</label>
                            <label style="color:red"> *</label>
                        </b-col>
                        <b-col lg="3" sm="3">
                            <label class="font-weight-bold">NIK</label>
                            <label style="color:red"> *</label>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="3" v-show="bpjsAuthValid">
                            <b-form-group style="position: relative">
                                <vue-select
                                    :options="spesialisasi"
                                    v-model="selectedSpesialisasi"
                                    placeholder="Pilih Spesialisasi"
                                />
                                <template v-if="selectedSpesialisasi == '' || selectedSpesialisasi == null">
                                    <label style="color: red">Kolom harus dipilih</label>
                                </template>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group style="position: relative">
                                <b-form-input
                                    v-model="formData.nomor_sip"
                                    type="text"
                                    required
                                    ref="nomor_sip"
                                />
                                <template v-if="formData.nomor_sip == '' || formData.nomor_sip == null">
                                    <label style="color: red">Kolom harus diisi</label>
                                </template>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group style="position: relative">
                                <DatePickerX v-model="formData.masa_berlaku_sip">
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <b-form-input
                                            :value="inputValue"
                                            v-on="inputEvents"
                                            :readonly="true"
                                            style="background-color:#ffffff;"
                                        ></b-form-input>
                                    </template>
                                </DatePickerX>
                                <font-awesome-icon
                                    icon="calendar"
                                    style="
                                    float: right !important;
                                    position: absolute;
                                    right: 15px;
                                    top: 12px;
                                    color: gray;
                                    "
                                />
                                <template v-if="formData.masa_berlaku_sip == '' || formData.masa_berlaku_sip == null">
                                    <label style="color: red">Kolom harus diisi</label>
                                </template>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group style="position: relative">
                                <b-form-input
                                    v-model="formData.nik"
                                    maxlength="16"
                                    type="text"
                                    required
                                    ref="nik"
                                    @input="
                                        cekValueNik($event);
                                        satusehat_docter_id = null;
                                        synced = false;
                                        syncing = false;
                                    "
                                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
                                />
                                <template v-if="formData.nik == '' || formData.nik == null">
                                    <label style="color: red">Kolom harus diisi</label>
                                </template>
                                <template v-else-if="formData.nik.match(/[^0-9/]+/) !== null">
                                    <label style="color: red">Hanya bisa menulis angka</label>
                                </template>
                                <template v-else-if="formData.nik.length < 16">
                                    <label style="color: red">NIK minimal 16 karakter</label>
                                </template>
                                <template v-else-if="!validasiNik && !loadEdit">
                                    <label style="color: red">NIK sudah digunakan</label>
                                </template>
                                <template v-else-if="validasiNik && !loadEdit">
                                    <label style="color: #1bc943">NIK dapat digunakan</label>
                                </template>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div class="row">
                        <div class="col-md" v-show="satusehatAuthValid">
                            <div style="display: flex; align-items: center;">
                                Sync dengan SatuSehat
                                <span class="ml-2">
                                    <font-awesome-icon
                                        v-if="synced"
                                        :icon="['fas', 'check-circle']"
                                        style="color: #1ad52f; font-size: 27px;"
                                    />
                                    <font-awesome-layers
                                        v-else
                                        style="font-size: 27px;"
                                    >
                                        <font-awesome-icon
                                            :icon="['far', 'circle']"
                                            style="opacity: 0.3;"
                                        />
                                        <font-awesome-icon
                                            :icon="['fas', 'sync']"
                                            transform="shrink-8"
                                            style="color: #3772d7;cursor:default;"
                                            spin
                                            v-if="syncing"
                                        />
                                        <font-awesome-icon
                                            v-else
                                            @click="syncHandler"
                                            :icon="['fas', 'sync']"
                                            transform="shrink-8"
                                            style="color: #3772d7;cursor: pointer;"
                                        />
                                    </font-awesome-layers>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md">
                            <template v-if="formData.status != 1 && !formData.is_owner">
                                <b-form-group style="position: relative">
                                    <label class="font-weight-bold">Account Status</label>
                                    <br>
                                    <b-form-checkbox
                                        v-model="accountStatus"
                                        switch
                                    >
                                        <label v-html="labelStatus"></label>
                                    </b-form-checkbox>
                                </b-form-group>
                            </template>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-md">
                            <template>
                                <b-button
                                    class="ml-3
                                    text-uppercase"
                                    variant="primary"
                                    style="font-size:17.5px;float:right;border-radius:0.65rem;"
                                    @click="submitForm"
                                >
                                    simpan
                                </b-button>
                                <b-button
                                    :to="{ name: 'dokter-list' }"
                                    class="text-uppercase"
                                    variant="danger"
                                    style="font-size:17.5px;float:right;border-radius:0.65rem;"
                                >
                                    tutup
                                </b-button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import startCase from "lodash/startCase";
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faClipboardList, faCalendar, faSync, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";
import moment from "moment";
moment.locale('id');
library.add( faClipboardList, faCalendar, faSync, farCircle, faCheckCircle );


export default {
    data: () => ({
        syncing: false,
        synced: false,
        beingSubmit: false,
        klinik_id: null,
        formData: {
            klinik_id: null,
            kode_dokter_bpjs: null,
            nama: null,
            email: null,
            nomor_telp: null,
            nomor_sip: null,
            masa_berlaku_sip: null,
            status: null,
            spesialisasi_id: null,
            nik:null
        },
        dokterBpjsList: [],
        spesialisasi: [],
        old_email: null,
        accountStatus: false,
        selectedSpesialisasi: null,
        selectedDokterBpjs: null,
        selectedKota: null,
        validasiEmail: true,
        validasiNoHP: true,
        validasiNik: true,
        noIzinBefore: null,
        noHPBefore: null,
        noNikBefore: null,
        loadEdit: true,
        labelStatus: null,
        failedEmail: false,
        satusehat_docter_id: null
    }),
    computed: {
        ...mapGetters(["getKlinikId", "bpjsAuthValid", "satusehatAuthValid"]),
    },
    beforeRouteLeave(to, from, next) {
        if (!this.beingSubmit && localStorage.getItem('IDLE') != 1) {
            this.$swal({
                title: startCase("keluar"),
                text: `Anda yakin untuk keluar dari halaman ini?`,
                type: "warning",
                showCancelButton: true,
                cancelButtonText: startCase("tidak"),
                confirmButtonText: startCase("ya")
            }).then(res => {
                if (res.value) {
                    next();
                } else {
                    next(false);
                }
            });
        } else {
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const { params } = to;
        const { user_id } = params;
        if (!user_id) {
            next({
                name: "dokter-list"
            });
        } else {
            next();
        }
    },
    mounted() {
        this.user_id = this.$router.currentRoute.params.user_id;
        this.getDokterData()
        this.getDokterBpjs()
    },
    watch: {
        accountStatus() {
            if(this.accountStatus) {
                this.formData.status = 2
                this.labelStatus = `<span class="text-primary font-weight-bold">Aktif</span>` 
            } else {
                this.formData.status = 3
                this.labelStatus = '<span class="text-danger font-weight-bold">Non-Aktif</span>'
            }
        }
    },
    components: {
        "vue-select": () => import("@/components/VueSelectClearable.vue"),
        "vue-select-x": () => import("@/components/VueSelect.vue"),
        DatePickerX: () => import('v-calendar/lib/components/date-picker.umd'),
    },
    methods: {
        tesSync: debounce(function() {
            this.synced = true;
        }, 700),
        syncHandler(){
            let err = false
            if(!this.syncing){
                if (this.formData.nik == '' || this.formData.nik < 15 || this.formData.nik == null || !this.validasiNik) {
                    this.$refs.nik.focus()
                    err = true
                }

                if (err) {
                    this.$swal({
                        text: `Silakan cek kembali NIK data Anda!`,
                        type: "warning"
                    });
                    return;
                }
                this.syncing = true;
                this.syncDocterSatusehat();
                // this.tesSync();
            }
        },
        async syncDocterSatusehat() {
            try {
                let errorMessage = 'NIK tidak ditemukan'
                const res = await this.$axios.post(
                    `satu-sehat/dokter/sync`,
                    {
                        dokter_user_id: this.$router.currentRoute.params.user_id,
                        klinik_id: this.getKlinikId,
                        nik: this.formData.nik
                    }
                );
            
                if(!res.data.status){
                    this.$swal({
                        text: errorMessage,
                        type: "error"
                    });
                    this.syncing = false;
                    return;
                }

                this.satusehat_docter_id = res.data.data.satusehat_docter_id
                this.synced = true;
            } catch (error) {
                this.syncing = false;
                this.$swal({
                    text: `Gagal melakukan Sync dengan Satu Sehat`,
                    type: "error"
                });
            }
        },
        async getDokterBpjs() {
            try {
                const res = await this.$axios.get(
                `bpjs/dokter?klinik_id=${this.getKlinikId}&first_row=0&limit=15`
                );
            
                this.dokterBpjsList = res.data.response.list.map(item => {
                    return {
                        id: item.kdDokter,
                        label: `${item.kdDokter} - ${item.nmDokter}`,
                        name: item.nmDokter
                    };
                });
            } catch (error) {}
        },
        onInputKodeBpjs(value) {
            if(Object(value).hasOwnProperty('label')) {
                this.formData.nama = value.name;
                this.formData.kode_dokter_bpjs = value;
            }
        },
        submitForm() {
            let err = false
            if (this.formData.nama == '' || this.formData.nama == null) {
                this.$refs.nama.focus()
                err = true
            } else if (this.formData.nomor_sip == '' || this.formData.nomor_sip == null) {
                this.$refs.nomor_sip.focus()
                err = true
            } else if (this.formData.email == '' || this.formData.email == null || !this.validasiEmail) {
                this.$refs.email.focus()
                err = true
            } else if (this.formData.nomor_telp == '' || this.formData.nomor_telp == null || !this.validasiNoHP) {
                this.$refs.nomor_telp.focus()
                err = true
            } else if (this.formData.nik == '' || this.formData.nik == null || !this.validasiNik || this.formData.nik.length < 15) {
                this.$refs.nik.focus()
                err = true
            } else if (this.selectedSpesialisasi == '' || this.selectedSpesialisasi == null) {
                this.$refs.nama.focus()
                window.scrollTo({
                    top: 260,
                    behavior: 'smooth'
                });
                this.$refs.nama.blur()
                err = true
            } else if (this.formData.masa_berlaku_sip == '' || this.formData.masa_berlaku_sip == null) {
                this.$refs.nama.focus()
                window.scrollTo({
                    top: 260,
                    behavior: 'smooth'
                });
                this.$refs.nama.blur()
                err = true
            }

            if (err) {
                this.$swal({
                    text: `Silakan cek kembali pengisian data Anda!`,
                    type: "warning"
                })
            } else {
                this.beingSubmit = true;
                this.editDokter();
            }
        },
        async editDokter() {
            try {
                if (this.old_email === this.formData.email) {
                    const res = await this.$axios.put(
                        `klinik/dokter`, {
                            ...this.formData,
                            kode_bpjs: this.selectedDokterBpjs ? this.selectedDokterBpjs.id : null,
                            id: this.$router.currentRoute.params.user_id,
                            klinik_id: this.getKlinikId,
                            masa_berlaku_sip: moment(this.formData.masa_berlaku_sip).format("YYYY-MM-DD"),
                            spesialisasi: typeof this.selectedSpesialisasi == 'object'
                                            ? this.selectedSpesialisasi.id
                                            : this.formData.spesialisasi_id,
                            satusehat_docter_id: this.satusehat_docter_id,
                            synced_to_satusehat: this.synced ? 1:0
                        }
                    );
                    if (res.data.status === true) {
                        this.$swal({
                            text: `Data user berhasil disimpan!`,
                            type: "success"
                        }).then(res => {
                            this.beingSubmit = true;
                            this.$router.push({
                                name: "dokter-list"
                            })
                        })
                    } else {
                        this.$swal({
                            text: `Data user gagal disimpan!`,
                            type: "warning"
                        })
                    }
                } else {
                    this.$swal({
                        text: `Penggantian email akan menyebabkan pengiriman email aktivasi ulang. Lanjutkan penggantian email?`,
                        type: "warning",
                        showCancelButton: true,
                        cancelButtonText: startCase("tidak"),
                        confirmButtonText: startCase("ya")
                    }).then(res => {
                        if (res.value) {
                            this.$axios.put(
                                    `klinik/dokter`, {
                                        ...this.formData,
                                        kode_bpjs: this.selectedDokterBpjs ? this.selectedDokterBpjs.id : null,
                                        id: this.$router.currentRoute.params.user_id,
                                        klinik_id: this.getKlinikId,
                                        masa_berlaku_sip: moment(this.formData.masa_berlaku_sip).format("YYYY-MM-DD"),
                                        spesialisasi: typeof this.selectedSpesialisasi == 'object'
                                                        ? this.selectedSpesialisasi.id
                                                        : this.formData.spesialisasi_id
                                    }
                                ).then((response) => {
                                    if (response.data.status === true) {
                                        this.$swal({
                                            text: `Email aktivasi berhasil dikirimkan`,
                                            type: "success"
                                        }).then(response => {
                                            this.beingSubmit = true;
                                            this.$router.push({
                                                name: "dokter-list"
                                            })
                                        })
                                    } else {
                                        this.$swal({
                                            text: `Data user gagal disimpan!`,
                                            type: "warning"
                                        })
                                    }
                                })
                                .catch((error) => {
                                });
                        } else {
                        }
                    });
                }

            } catch (err) {
            } finally {
                this.beingSubmit = false;
            }
        },
        async getDokterData() {
            try {
                const res = await this.$axios.get(
                    `klinik/dokter/${this.user_id}?klinik_id=${this.getKlinikId}`
                );
                const { status, data } = res.data;

                if(data == null) {
                    this.$swal({
                        text: `Data user tidak ada`,
                        type: "warning"
                    }).then(res => {
                        this.beingSubmit = true;
                        this.$router.push({
                            name: "dokter-list"
                        })
                    })
                } else {
                    this.formData = data
                    this.formData.klinik_id = this.getKlinikId
                    this.formData.masa_berlaku_sip = new Date(data.masa_berlaku_sip)
                    this.noIzinBefore = data.email
                    this.old_email = data.email
                    this.noHPBefore = data.nomor_telp
                    this.noNikBefore = data.nik
                    this.satusehat_docter_id = data.satusehat_docter_id
                    this.synced = data.synced_to_satusehat == 1 ? true : false;
                    if(data.status == '2') this.accountStatus = true
                    else if(data.status == '3') this.accountStatus = false
                    if(data.kode_bpjs) {
                        this.formData.kode_dokter_bpjs = {
                            id: data.kode_bpjs,
                            label: `${data.kode_bpjs} - ${data.nama}`,
                            name: data.nama
                        }
                        this.selectedDokterBpjs = this.formData.kode_dokter_bpjs
                    }

                    this.getSpesialisasi()
                }
            } catch (err) {
                // console.log(err);
            }
        },
        async getSpesialisasi() {
            try {
                const res = await this.$axios.get(`spesialisasi`)
                const { data } = res.data

                this.spesialisasi = data.spesialisasi.map(val => (
                    this.formData.spesialisasi_id == val.id ? this.selectedSpesialisasi = val.nama : null,
                    {
                        ...val,
                        label: `${val.nama}`,
                    }
                ));
            } catch (error) {
                // console.error(error);
            }
        },
        cekValueEmail: debounce(function(val) {
            if(this.old_email.toLowerCase() == val.toLowerCase()){
                return this.validasiEmail = true
            }

            if(this.formData.email.match(/^([A-Za-z][A-Za-z0-9\-\.\_\+]*)\@([A-Za-z][A-Za-z0-9\-\_\+]*)(\.[A-Za-z][A-Za-z0-9\-\_\+]*)+$/) == null) {
                this.failedEmail = true
            } else {
                this.failedEmail = this.loadEdit = false
                this.$axios.get(
                    `klinik/dokter/email/cek`,
                    {
                        params: {
                            klinik_id: this.getKlinikId,
                            email: this.formData.email,
                            is_edit: true
                        }
                    }
                  )
                .then(res => {
                    if (val == this.noIzinBefore) {
                        this.validasiEmail = true
                    } else if (res.data.status) {
                        this.validasiEmail = true
                    } else if (!res.data.status) {
                        this.validasiEmail = false
                    }
                })
            }
        }, 500),
        cekValueHP: debounce(function(val) {
            if(
                this.formData.nomor_telp != ''
                && this.formData.nomor_telp != null
                && this.formData.nomor_telp.length > 9
                && this.formData.nomor_telp.match(/[^0-9/]+/) == null
            ) {
                this.loadEdit = false
                this.$axios.get(
                    `klinik/dokter/phone/cek`,
                    {
                        params: {
                            klinik_id: this.getKlinikId,
                            phone: this.formData.nomor_telp
                        }
                    }
                  )
                .then(res => {
                    if (val == this.noHPBefore) {
                        this.validasiNoHP = true
                    } else if (res.data.status) {
                        this.validasiNoHP = true
                    } else if (!res.data.status) {
                        this.validasiNoHP = false
                    }
                })
            }
        }, 500),
        cekValueNik: debounce(function(val) {
            if(this.noNikBefore == val){
                return this.validasiNik = true
            }

            if(
                this.formData.nik != ''
                && this.formData.nik != null
                && this.formData.nik.length > 14
                && this.formData.nik.match(/[^0-9/]+/) == null
            ) {
                this.loadEdit = false
                this.$axios.get(
                    `klinik/dokter/nik/cek`,
                    {
                        params: {
                            klinik_id: this.getKlinikId,
                            nik: this.formData.nik
                        }
                    }
                  )
                .then(res => {
                    if (val == this.noNikBefore) {
                        this.validasiNik = true
                    } else if (res.data.status) {
                        this.validasiNik = true
                    } else if (!res.data.status) {
                        this.validasiNik = false
                    }
                })
            }
        }, 500),
    }
};
</script>
<style lang="scss">
    .custom-dropzone {
        .dz-message {
            padding: 10rem 1rem;
        }
    }
</style>